<template>
  <div class="app-forgot-password-succeeded">
    <div class="headline">
      <h4>
        <slot name="headline"></slot>
      </h4>
    </div>
    <div class="subline">
      <slot name="subline"></slot>
    </div>
    <Stepper
      class="stepper"
      @next="back()"
      :show-prev="false"
    >
      <template slot="btnNext">
        <slot name="ctaPrevious">Erneut Senden</slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import moment from 'moment/src/moment'
import { mapGetters, mapMutations } from 'vuex'
import Stepper from '@/components/generic/Stepper.vue'

export default {
  name: 'ForgotPasswordSucceeded',
  components: { Stepper },
  data () {
    return {
      now: new Date(),
      interval: null
    }
  },
  created: function () {
    this.startTimer()
  },
  destroyed () {
    clearInterval(this.interval)
  },
  computed: {
    ...mapGetters('forgotPassword', [
      'validityPeriod'
    ]),
    transformToDayFormat: function () {
      return moment(String(this.validityPeriod)).format('DD.MM.YYYY, HH:mm')
    },
    transformToCountdown: function () {
      return moment.utc(this.countDown).format('mm:ss')
    },
    countDown () {
      return moment(this.validityPeriod) - moment(this.now)
    },
    countdownCheck () {
      return this.countDown > 0
    },
    slotData () {
      return {
        countdownCheck: this.countdownCheck,
        transformToDayFormat: this.transformToDayFormat,
        transformToCountdown: this.transformToCountdown
      }
    }
  },
  methods: {
    ...mapMutations('forgotPassword', [
      'setView'
    ]),
    startTimer () {
      this.interval = setInterval(function () {
        this.now = new Date()
      }.bind(this), 1000)
    },
    back () {
      this.setView('input')
    }
  }
}
</script>
